var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stream-url" },
    [
      !_vm.isEdit
        ? _c(
            "div",
            { staticClass: "stream-url__read" },
            [
              _vm.stream.url
                ? _c(
                    "a",
                    {
                      staticClass: "stream-url__value",
                      attrs: { href: _vm.stream.url, target: "_blank" },
                    },
                    [_vm._v(_vm._s(_vm.stream.url))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("Icon", {
                attrs: { id: "edit" },
                on: {
                  click: function ($event) {
                    _vm.isEdit = true
                  },
                },
              }),
            ],
            1
          )
        : _c("EditText", {
            staticClass: "stream-url__edit",
            on: {
              cancel: _vm.cancel,
              apply: _vm.apply,
              paste: (v) => _vm.paste(v),
            },
            model: {
              value: _vm.editable,
              callback: function ($$v) {
                _vm.editable = $$v
              },
              expression: "editable",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }